export enum HisSearchSelectionSetting {
    NoSelect,
    SingleSelect,
    MultiSelect
}